import React from "react";
import checked from "./../../../Images/checked.png";

const HairSalonNearMeWhy = () => {
  return (
    <div className="hairSalonNearMeWhy">
      <h5>Why SCENT is the Best Hair Salon Near Me for Your Hair Goals?</h5>
      <p>
        When you search for a hair salon near me, you’re likely looking for a
        salon that can meet your needs, provide a high level of care, and leave
        you feeling satisfied. At SCENT, we go above and beyond to ensure that
        every client leaves with a smile. Here’s why SCENT is the perfect
        choice:
      </p>
      <ul>
        <li>
          <span>
            <img src={checked} alt="checked" />
            Personalized Consultations{" "}
          </span>
          <p>
            No two clients are the same, and neither are their hair needs. Our
            stylists offer personalized consultations to understand your unique
            hair goals. Whether you’re going for a subtle change or a bold new
            look, SCENT is the hair salon near me that listens to what you want
            and delivers results.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={checked} alt="checked" />
            Latest Trends and Techniques{" "}
          </span>
          <p>
            Our stylists are always in tune with the latest hair trends, from
            celebrity-inspired cuts to trending color techniques. If you’re
            someone who loves to stay on-trend, SCENT is the hair salon near me
            that will keep you looking stylish and fresh.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={checked} alt="checked" />
            Attention to Detail{" "}
          </span>
          <p>
            We believe in perfection. Our team pays attention to the small
            details, ensuring that your hair looks flawless from every angle.
            Whether it’s a cut, color, or treatment, SCENT is the hair salon
            near me that leaves no strand unattended.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={checked} alt="checked" />
            4. Commitment to Customer Satisfaction{" "}
          </span>
          <p>
            Your satisfaction is our priority. We strive to make every visit a
            luxurious experience, ensuring that you leave feeling pampered and
            happy with the results. Need adjustments? No problem. SCENT is the
            hair salon near me where your happiness comes first.
          </p>
        </li>{" "}
      </ul>
    </div>
  );
};

export default HairSalonNearMeWhy;
